'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  max-width: 100%;\n  height: auto;\n  transition: transform 0.3s ease;\n'], ['\n  display: inline-block;\n  max-width: 100%;\n  height: auto;\n  transition: transform 0.3s ease;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  overflow: hidden;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  ', '};\n  &:hover {\n    ', ' {\n      transform: scale(1.1);\n    }\n  }\n'], ['\n  overflow: hidden;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  ', '};\n  &:hover {\n    ', ' {\n      transform: scale(1.1);\n    }\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n        width: ', ';\n        height: ', ';\n      '], ['\n        width: ', ';\n        height: ', ';\n      ']),
    _templateObject4 = _taggedTemplateLiteral(['\n        width: ', ';\n        height: 100%;\n        ', ' {\n          width: ', ';\n          height: 100%;\n        }\n      '], ['\n        width: ', ';\n        height: 100%;\n        ', ' {\n          width: ', ';\n          height: 100%;\n        }\n      ']),
    _templateObject5 = _taggedTemplateLiteral(['\n        width: 100%;\n        height: ', ';\n        ', ' {\n          width: 100%;\n        }\n      '], ['\n        width: 100%;\n        height: ', ';\n        ', ' {\n          width: 100%;\n        }\n      ']),
    _templateObject6 = _taggedTemplateLiteral(['\n      width: 100%;\n      height: 100%;\n      ', ' {\n        width: 100%;\n      }\n    '], ['\n      width: 100%;\n      height: 100%;\n      ', ' {\n        width: 100%;\n      }\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n  height: 100%;\n  width: 100%;\n  box-shadow: inset 0 0 ', ' ', '\n    ', ';\n\n  &:after,\n  &:before {\n    content: \'\';\n    position: absolute;\n    transform: rotate(45deg);\n    left: 0;\n    right: 0;\n    height: ', ';\n    top: 50%;\n    background: ', ';\n  }\n\n  &:before {\n    transform: rotate(-45deg);\n  }\n\n  position: relative;\n  vertical-align: middle;\n'], ['\n  height: 100%;\n  width: 100%;\n  box-shadow: inset 0 0 ', ' ', '\n    ', ';\n\n  &:after,\n  &:before {\n    content: \'\';\n    position: absolute;\n    transform: rotate(45deg);\n    left: 0;\n    right: 0;\n    height: ', ';\n    top: 50%;\n    background: ', ';\n  }\n\n  &:before {\n    transform: rotate(-45deg);\n  }\n\n  position: relative;\n  vertical-align: middle;\n']);

var _polished = require('polished');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Loader = require('../Loader');

var _Loader2 = _interopRequireDefault(_Loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Img = _styledComponents2.default.img(_templateObject);

var Wrapper = _styledComponents2.default.div(_templateObject2, function (_ref) {
  var width = _ref.width,
      height = _ref.height;

  if (width && height) {
    return (0, _styledComponents.css)(_templateObject3, width, width);
  } else if (width) {
    return (0, _styledComponents.css)(_templateObject4, width, Img, width);
  } else if (height) {
    return (0, _styledComponents.css)(_templateObject5, height, Img);
  }
  return (0, _styledComponents.css)(_templateObject6, Img);
}, Img);

var NoImage = _styledComponents2.default.div(_templateObject7, (0, _polished.rem)(0), (0, _polished.rem)(2), function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.separatorColor;
}, (0, _polished.rem)(2), function (_ref3) {
  var theme = _ref3.theme;
  return theme.color.separatorColor;
});

var Image = function (_Component) {
  _inherits(Image, _Component);

  function Image(props) {
    _classCallCheck(this, Image);

    var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));

    _this.state = {
      isFetching: false,
      error: false
    };

    _this.handleLoad = _this.handleLoad.bind(_this);
    _this.handleError = _this.handleError.bind(_this);
    _this.imgEl = null;
    if (typeof document !== 'undefined') {
      _this.imgEl = document.createElement('img');
    }
    return _this;
  }

  _createClass(Image, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.init(this.props.src);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.src !== this.props.src) {
        this.init(nextProps.src);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.imgEl) {
        this.imgEl.removeEventListener('load', this.handleLoad);
        this.imgEl.removeEventListener('error', this.handleError);
      }
    }
  }, {
    key: 'init',
    value: function init(src) {
      if (this.imgEl) {
        // remove ol' listeners
        this.imgEl.removeEventListener('load', this.handleLoad);
        this.imgEl.removeEventListener('error', this.handleError);
      }

      if (!src) {
        return;
      }

      this.setState({ isFetching: true });

      if (this.imgEl) {
        // add new listeners
        this.imgEl.addEventListener('load', this.handleLoad);
        this.imgEl.addEventListener('error', this.handleError);

        this.imgEl.src = src;
      }
    }
  }, {
    key: 'handleLoad',
    value: function handleLoad() {
      this.setState({
        isFetching: false,
        error: false
      });
    }
  }, {
    key: 'handleError',
    value: function handleError() {
      this.setState({
        isFetching: false,
        error: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          src = _props.src,
          alt = _props.alt,
          height = _props.height,
          width = _props.width,
          restProps = _objectWithoutProperties(_props, ['src', 'alt', 'height', 'width']);

      var _state = this.state,
          isFetching = _state.isFetching,
          error = _state.error;

      // append units

      var heightParsed = Number(height);
      if (Number.isNaN(heightParsed)) {
        heightParsed = height;
      } else {
        heightParsed = height + 'px';
      }
      var widthParsed = Number(width);
      if (Number.isNaN(widthParsed)) {
        widthParsed = width;
      } else {
        widthParsed = width + 'px';
      }

      if (isFetching) {
        return _react2.default.createElement(
          Wrapper,
          _extends({}, restProps, { height: heightParsed, width: widthParsed }),
          _react2.default.createElement(_Loader2.default, null)
        );
      }

      if (error || !src) {
        return _react2.default.createElement(
          Wrapper,
          _extends({}, restProps, {
            title: alt,
            height: heightParsed,
            width: widthParsed
          }),
          _react2.default.createElement(NoImage, null)
        );
      }

      return _react2.default.createElement(
        Wrapper,
        _extends({}, restProps, { height: heightParsed, width: widthParsed }),
        _react2.default.createElement(Img, { src: src })
      );
    }
  }]);

  return Image;
}(_react.Component);

Image.propTypes = {
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  src: _propTypes2.default.string,
  alt: _propTypes2.default.string
};

Image.defaultProps = {
  width: undefined,
  height: undefined,
  src: null,
  alt: null
};

exports.default = Image;
Image.__docgenInfo = [{
  'description': '',
  'displayName': 'Image',
  'methods': [{
    'name': 'init',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'src',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'handleLoad',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }, {
    'name': 'handleError',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }],
  'props': {
    'height': {
      'type': {
        'name': 'union',
        'value': [{
          'name': 'number'
        }, {
          'name': 'string'
        }]
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      }
    },
    'width': {
      'type': {
        'name': 'union',
        'value': [{
          'name': 'number'
        }, {
          'name': 'string'
        }]
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      }
    },
    'src': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'alt': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/Image/index.js'] = {
    name: 'Image',
    docgenInfo: Image.__docgenInfo,
    path: 'src/Image/index.js'
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/Image/index.js
// module id = 315
// module chunks = 1